import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Box, Button, Typography } from '@material-ui/core';

import { Payment, ReservationDetails } from '../../types';
import { updatePaymentFlag, useMutateApiData } from '../../util/api';
import { ErrorMessage } from '../common';
import SwitchField from '../common/section/SwitchField';

type Props = Pick<ReservationDetails, 'reservation'>;

const PaymentDetails: React.FC<Props> = ({ reservation }) => {
  const { t } = useTranslation();

  const { id, payment } = reservation;
  const { error, isLoading, mutateAsync: updatePaymentFlagRequest } = useMutateApiData(updatePaymentFlag);

  const [details, setDetails] = React.useState<Payment>({
    paymentAR: payment?.paymentAR || false,
  });
  const onPaymentARChange = (detail: keyof Payment, value: any): void => {
    setDetails({
      ...details,
      [detail]: value,
    });
  };

  const onSubmit = async (): Promise<void> => {
    await updatePaymentFlagRequest([id, details]);
  };

  return (
    <>
      <SwitchField
        field="paymentAR"
        label={t('paymentDetails.paymentAR')}
        onChange={onPaymentARChange}
        value={details.paymentAR}
      />
      <Box flexDirection="row">
        <Button variant="outlined" color="primary" onClick={onSubmit} disabled={isLoading}>
          {t('general.save')}
        </Button>
        {isLoading && <Typography>{t('general.loading')}</Typography>}
      </Box>
      {error && <ErrorMessage message={t('general.error')} />}
      <Box flexDirection="row" marginTop={'1rem'}>
        <Typography component="span" variant="body2">
          <Trans i18nKey="paymentDetails.paymentLinkInfo" components={{ strong: <strong /> }} />
        </Typography>
      </Box>
    </>
  );
};

export default PaymentDetails;
